import { useFilterOptions } from '@/hooks/useFilterOptions';
import FilterOptionsList from '@/components/Ui/FilterOptions/FilterOptionsList';
import { Button } from '@/components/Common';

type FilterOptionsProps = {
  title: string;
  categories: {
    id: string;
    label: string;
    count: number;
    hasSearch?: boolean;
  }[];
  optionsData: Record<string, { id: string; value: string; label: string }[]>;
  onApplyFilters: () => void;
  onClearFilters: () => void;
};

const FilterOptions = ({
  title,
  categories,
  optionsData,
  onApplyFilters,
  onClearFilters,
}: FilterOptionsProps) => {
  const {
    selectedCategory,
    selectedOptions,
    handleOptionToggle,
    setSelectedCategory,
    getSelectedCount,
    currentOptions,
  } = useFilterOptions({
    initialCategories: categories,
    optionsData,
  });

  return (
    <>
      <div className="rounded-lg w-[443px] h-[400px] mx-auto">
        <div className="mb-6">
          <h2 className="text-white text-xl font-semibold">{title}</h2>
        </div>

        <div className="mb-6">
          <FilterOptionsList
            categories={categories}
            options={currentOptions}
            selectedOptions={selectedOptions}
            onOptionToggle={handleOptionToggle}
            selectedCategory={selectedCategory}
            onCategorySelect={setSelectedCategory}
            getSelectedCount={getSelectedCount}
          />
        </div>
      </div>
      <div className="bg-[#1B1B1B]">
        <div className="w-[443px] h-[86px] mx-auto flex items-center justify-between mt-[131px] z-50">
          <Button
            className="w-[168.32px] h-[46px] !bg-[#131311] text-primary font-semibold text-[15.65px]"
            onClick={onClearFilters}
            title="Effacer"
          />

          <Button
            className="w-[168.32px] h-[46px]"
            onClick={onApplyFilters}
            title="Appliquer"
          />
        </div>
      </div>
    </>
  );
};

export default FilterOptions;
